export default __webpack_public_path__ + "static/TSD_Reports_Hero-3bbabc07aa371823d9cd664ab61e42c6.png";